// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".k1xP4iqEaOT15kgCvo98{position:absolute;top:0px;z-index:2147483648}.v3U48bCCd4zu4lNmqDVH{position:absolute;top:0px;z-index:2147483648;pointer-events:none}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"closeBtnPosition": "k1xP4iqEaOT15kgCvo98",
	"countDownCloseBtnPosition": "v3U48bCCd4zu4lNmqDVH"
};
export default ___CSS_LOADER_EXPORT___;
